import { Stack, StackProps, styled, Typography, TypographyProps } from '@mui/material';
import AcadlyDialog, { dialogClasses } from '../../../../../../../components/Dialog';
import AcadlyHeader, { headerClasses } from '../../../../../../../components/Header';
import { hexToRgba } from '../../../../../../../utils/color';
import AcadlyClassCard from '../../../../../../class/ClassCard';
import { classCardClasses } from '../../../../../../class/ClassCard/styles';
import AcadlyCourseCard from '../../../../../../course/CourseCard';
import { courseCardClasses } from '../../../../../../course/CourseCard/styles';
import AcadlyPollCard from '../../../../../PollCard';
import { activityWidgetClasses } from '../../../../../../../components/ActivityWidget/styles';

export const Dialog = styled(AcadlyDialog)(({ theme }) => ({
  [`& .${dialogClasses.container}`]: {
    containerType: 'inline-size',

    [`& .${dialogClasses.paper}`]: {
      fontSize: 'clamp(10px, 1.3cqw, 16px)',
      maxWidth: 'unset',
      width: '100%',
      padding: theme.spacing(2),
      margin: theme.spacing(8, 4),
      gap: theme.spacing(1),
      borderRadius: theme.spacing(4),
    },
    [`& .${dialogClasses.body}`]: {
      display: 'flex',
      flexDirection: 'column',
      padding: theme.spacing(0),
      gap: theme.spacing(1),
    },
    [`& .${dialogClasses.footer}`]: {
      justifyContent: 'unset',
      borderTop: 'none',
    },
  },
}));

export const Header = styled(AcadlyHeader)(({ theme }) => ({
  width: '100%',
  padding: theme.spacing(2),
  gap: theme.spacing(2),
  minHeight: 'unset',
  borderBottom: 'none',
  [`& .${headerClasses.action}`]: {
    padding: theme.spacing(1),
  },
}));

export const Card = styled((props: StackProps) => <Stack p={2} gap={2} {...props} />)(({ theme }) => {
  return {
    backgroundColor: hexToRgba(theme.palette.primary[100], 0.5),
    borderRadius: theme.spacing(1),
  };
});
export const CardTitle = styled((props: TypographyProps) => (
  <Typography variant="textSmBold" textTransform="uppercase" {...props} />
))(({ theme }) => ({
  color: theme.palette.primary[500],
  fontSize: theme.typography.pxToEm(12),
}));

export const CourseCard = styled(AcadlyCourseCard)(({ theme }) => ({
  [`& .${courseCardClasses.header}`]: {
    padding: `${theme.typography.pxToEm(9)} ${theme.typography.pxToEm(15)}`,
  },

  [`& .${courseCardClasses.zoomUsIcon}`]: {
    fontSize: theme.typography.pxToEm(24),
    height: theme.typography.pxToEm(16),
    width: theme.typography.pxToEm(16),
  },

  [`& .${courseCardClasses.courseCode} `]: {
    fontSize: theme.typography.pxToEm(12),
  },

  [`& .${courseCardClasses.content}`]: {
    padding: `${theme.typography.pxToEm(9)} ${theme.typography.pxToEm(15)}`,
  },

  [`& .${courseCardClasses.courseTitle}`]: {
    fontSize: theme.typography.pxToEm(16),
    marginBottom: theme.typography.pxToEm(10),
  },

  [`& .${courseCardClasses.userAvatarSkeleton}`]: {
    height: `${theme.typography.pxToEm(18)} !important`,
    width: `${theme.typography.pxToEm(18)} !important`,
  },

  [`& .${courseCardClasses.adminNameSkeleton}`]: {
    height: `${theme.typography.pxToEm(18)} !important`,
    width: `${theme.typography.pxToEm(100)} !important`,
  },

  [`& .${courseCardClasses.footer}`]: {
    padding: `${theme.typography.pxToEm(9)} ${theme.typography.pxToEm(15)}`,
  },

  [`& .${courseCardClasses.role} > *`]: {
    fontSize: theme.typography.pxToEm(10),
  },

  [`& .${courseCardClasses.calendarIcon}`]: {
    fontSize: theme.typography.pxToEm(24),
    height: theme.typography.pxToEm(12),
    width: theme.typography.pxToEm(12),
  },
}));

export const ClassCard = styled(AcadlyClassCard)(({ theme }) => ({
  [`& .${classCardClasses.classGrid}`]: {
    padding: theme.typography.pxToEm(15),
  },

  [`& .${classCardClasses.zoomUsIcon}`]: {
    fontSize: theme.typography.pxToEm(24),
    height: theme.typography.pxToEm(12),
    width: theme.typography.pxToEm(12),
  },

  [`& .${classCardClasses.inSessionTag} > *, & .${classCardClasses.completedTag} > *, & .${classCardClasses.activityName}`]:
    {
      fontSize: theme.typography.pxToEm(10),
    },

  [`& .${classCardClasses.timings}, & .${classCardClasses.title}`]: {
    fontSize: theme.typography.pxToEm(16),
  },

  [`& .${classCardClasses.activities}`]: {
    height: theme.typography.pxToEm(48),
  },

  [`& .${classCardClasses.activities} > *`]: {
    height: `${theme.typography.pxToEm(26)} !important`,
    width: `${theme.typography.pxToEm(26)} !important`,
  },
}));

export const PollCard = styled(AcadlyPollCard)(({ theme }) => ({
  [`& .${activityWidgetClasses.root}`]: {
    padding: theme.typography.pxToEm(9),
  },

  [`& .${activityWidgetClasses.icon} > svg`]: {
    fontSize: theme.typography.pxToEm(24),
    height: theme.typography.pxToEm(19),
    width: theme.typography.pxToEm(19),
  },

  [`& .${activityWidgetClasses.title}`]: {
    fontSize: theme.typography.pxToEm(12),
  },

  [`& .${activityWidgetClasses.description}`]: {
    fontSize: theme.typography.pxToEm(10),
  },

  [`& .${activityWidgetClasses.tag} > *`]: {
    height: `${theme.typography.pxToEm(18)} !important`,
    width: `${theme.typography.pxToEm(56)} !important`,
  },
}));
